<template>
  <div class="detail">
    <div class="container">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("bulkTradeDetail.home")}}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/besinessScope/bulkTrade' }">{{$t("bulkTradeDetail.lists")}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <section class="head">
        <el-row :gutter="30">
          <el-col :span="8" :xs="24">
            <div data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
              <img :src="bulkTradeDetail.mainPicUrl" />
            </div>
          </el-col>
          <el-col :span="16" :xs="24" class="product-lists">
            <div class="headline2">
                <span>{{bulkTradeDetail.itemName}}</span><span>_</span><span>{{  bulkTradeDetail.enItemName?bulkTradeDetail.enItemName.toUpperCase():'' }}</span>
            </div>
            <p class="des">{{bulkTradeDetail.introduction}} </p>
            <div class="share hidden-xs-only">
              <span class="mr20">{{$t("bulkTradeDetail.share")}}</span>

              <el-popover placement="bottom" width="380" trigger="hover">
                <div class="popover-pic" ref='imageDom' >
                  <!-- <img :src="bulkTradeDetail.mainPicUrl+'?'+new Date().getTime()"  crossorigin="anonymous"/> -->
                  
                  <h3>{{bulkTradeDetail.itemName}}</h3>
                  <p>{{bulkTradeDetail.introduction}}</p>
                  
                  <div class="code">
                    <img src="../../../assets/img/base/logo.png" class="logo"/>
                    <img src="../../../assets/img/base/gzh.png" class="gzh"/>
                  </div>
                </div>
              
                <div class="save-btn">
                  <el-button block @click="setCanvas(bulkTradeDetail.itemName)" size="mini">保存图片</el-button>
                </div>
                  
                <el-button slot="reference" circle><img src="../../../assets/img/businessScope/bulkTrade/pic_icon.png" alt=""/></el-button>
              </el-popover>

              <el-popover
                placement="bottom"
                trigger="hover"
                :content="$t('bulkTradeDetail.copyAddress')"
                width="150"
                class="ml20">
                <el-button slot="reference" circle @click="copeLike"><img src="../../../assets/img/businessScope/bulkTrade/link_icon.png" alt=""/></el-button>
              </el-popover>

            </div>
          </el-col>
        </el-row>
      </section>
      <div class="introduction">
        <div class="headline2">
            <span>{{$t("bulkTradeDetail.productIntroduction")}}</span><span>_</span><span>Product introduction</span>
        </div>

        <div class="des" v-html="bulkTradeDetail.itemAttribute"></div>
        
      </div>
      <div class="factory" v-if="bulkTradeDetail.picLists && bulkTradeDetail.picLists.length">
        <div class="headline2">
            <span>{{$t("bulkTradeDetail.factoryIntroduction")}}</span><span>_</span><span>Factory introduction</span>
        </div>

        <el-row :gutter="30">
          <el-col :span="8" :xs="12" v-for="(item,index) in bulkTradeDetail.picLists" :key="index">
            <div data-swiper-parallax="-300" data-swiper-parallax-duration="1000" class="pic">
              <img :src="item.itemPicUrl" />
            </div>
          </el-col>
        </el-row>
        
      </div>
      <div class="recommend">
          <div class="headline2">
              <span>{{$t("mainBusiness.gpc.recommend.headline2.title")}}</span><span>_</span><span>Relevant recommendation</span>
          </div>
          <el-row :gutter="30">
              <el-col :span="6" :xs="12" v-for="(item,index) in bulkTradeDetail.aboutItems" :key="index" @click.native="toDetail(item.itemNo)">
                  <div class="pic" :style="{height:imgH+'px'}" ref="pic">
                      <img :src="item.mainPicUrl" />
                  </div>
                  <div class="des-row">
                      <p>{{item.itemName}}</p>
                  </div>
              </el-col>
          </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getItemdetail } from "@/api/product"
import dialogContact from "../../../components/dialog_contact";
import html2canvas from "html2canvas"
export default {
  name: "ProductDetail",
  data() {
    return {
      bulkTradeDetail: {}, //产品信息
      imgH:0
    };
  },
  computed:{
    ...mapGetters(['language']),
    getItemNo(){
      return this.$route.params.id
    }
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();

    getItemdetail(this.language, this.getItemNo ).then(res=>{
     this.bulkTradeDetail = res.data;
     this.$nextTick(()=>{
        this.imgH=this.$refs.pic[0].offsetWidth;
      })
    })
  },
  components: {
    dialogContact
  },
  methods: {
    toDetail(itemNo){
      this.$router.push({path:`/besinessScope/bulkTrade/detail/${itemNo}`});
      location.reload();
    },
    copeLike(){
      this.$copyText(document.location.href).then( (e)=> {
          this.$message.success('复制成功');
        }, function (e) {
          this.$message.error('复制失败');
      })
    },
    setCanvas (name) {
      const canvas = document.createElement('canvas')
      // 获取要生成图片的 DOM 元素
      let canvasDom = this.$refs.imageDom
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(canvasDom).width)
      const height = parseInt(window.getComputedStyle(canvasDom).height)
      // 宽高扩大 2 倍 处理图片模糊
      canvas.width = width 
      canvas.height = height 
      canvas.style.width = width  + 'px'
      canvas.style.height = height  + 'px'

      const context = canvas.getContext('2d')
      context.scale(1, 1)
      const options = {
        backgroundColor: null,
        canvas: canvas,
        useCORS: true
      }

      html2canvas(canvasDom,options).then(canvas => {
        // console.log(canvas)
        // 兼容ie
        if(window.navigator.msSaveBlob){
          var blob = canvas.msToBlob()
          window.navigator.msSaveBlob(blob, name+'.png')
        } else {
          var url = canvas.toDataURL('image/png')     //把canvas转成base64
          // <a id="tttt" href="" style="display:none"></a>  这是html，随便放页面的哪里都行
          // 写一个隐藏的按标签，借助按标签的download属性下载图片
          let aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.download = name+".png";
          aLink.click()
        }
      })
  
    }
  },
};
</script>

<style scoped lang="scss">
.breadcrumb{
  margin:50px 0;
}
.head{
  margin:80px 0;
  .headline2{
    margin-top:0;
    margin-bottom:20px;
  }
  .share{
    margin-top:30px;
  }
  .des{
    text-align: justify;
  }
}
.el-popover.el-popper{
  .popover-pic{
    box-sizing: border-box;
    background:#fff;
    padding:15px;
    h3{
      font-weight: bold;
    }
    .code{
      padding-top:15px;
      margin-top:15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top:1px solid #999;
      .logo{
        width:200px;
      }
      .gzh{
        width:100px;
      }
    }
  }
  .save-btn{
      position:absolute;
      right:0;
      bottom:0;
  }
}
.introduction{
  .des{
    margin-bottom:40px;
    text-align: justify;
  }
}
.factory{
  img{
    width:100%;
    height:300px;
    object-fit: cover;
    margin-bottom:20px;
  }
}
.recommend{
    .pic{
        height:300px;
        border-radius: 22px;
        overflow: hidden;
        // background: #F4F4F4;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        
        img{
          object-fit: cover;
          height:100%;
          width:100%;
        }
    }
    .des-row{
        padding:15px;
    }
}

@media screen and (max-width:768px){
  .breadcrumb{
    margin:30px 0;
  }
  .head{
    margin:40px 0;
    .product-lists{
      margin-top:20px;
    }
  }
}
</style>
